import { Box, Divider, Grid, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Catalogo from "./Catalogo";
import { useDispatch, useSelector } from "react-redux";
import { galleryActions } from "../actions";
import Carrousel from "../components/Carrousel";

const styles = {
  PaperContainerFirst: {
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    height: "240px",
    "&:hover": {
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      transform: "scale(1.03)",
    },
  },
  BoxImage: {
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  Image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};


const Mobile = ({ image, label, index }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.account);

  const navigateCategory = (categoria) => {
    if (categoria === "Lanzamientos") {
      dispatch(galleryActions.setSearchTerm(""));
      dispatch(galleryActions.setCategoria(""));
      dispatch(galleryActions.setRubro(""));
      dispatch(galleryActions.setSubRubro(""));
      dispatch(galleryActions.setPromocion("Lanzamient"));
      navigate(isLoggedIn ? "/products" : "/catalogo");
    } else {
      const categoriaMapeada =
        categoria === "Oficina Y Hogar" ? "Oficina" : categoria;
      dispatch(galleryActions.setCategoria(categoriaMapeada));
      navigate(`/categoria/${categoriaMapeada}`);
    }
  };

  return (
    <Paper
      key={`${index}-${label}`}
      elevation={3}
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        cursor: "pointer",
      }}
      onClick={() => navigateCategory(label)}
      aria-label={`Ir a la categoría ${label}`}
    >
      {label === "Lanzamientos" ?
        <Carrousel
          image={image}
          isBannerBig={true}
        />
        : <div
          style={{
            position: "relative",
            width: "100%",
            paddingBottom: "56.25%",
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />}

    </Paper>
  );
};

const BoxImageContainer = ({ image, label, index, flex = "", isImage = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.account);


  const navigateCategory = (categoria) => {
    if (categoria === "Lanzamientos") {
      dispatch(galleryActions.setSearchTerm(""));
      dispatch(galleryActions.setCategoria(
        categoria === "Lanzamientos" ? "" : categoria === "Oficina Y Hogar" ? "Oficina" : categoria));
      dispatch(galleryActions.setRubro(""));
      dispatch(galleryActions.setSubRubro(""));
      dispatch(galleryActions.setPromocion(categoria === "Lanzamientos" ? "Lanzamient" : ""));
      navigate(isLoggedIn ? "/products" : "/catalogo");
      return
    }
    navigate(`/categoria/${categoria}`)
  };


  return (
    <Paper key={`${index}-${label}`} elevation={4} sx={{ ...styles.PaperContainerFirst, flex, width: "100%", }} onClick={() => navigateCategory(label)}>
      {!isImage ? <Box style={{ ...styles.BoxImage, backgroundImage: `url(${image})`, }} /> : label === "Lanzamientos" ?
        <Carrousel
          image={image}
          isBannerBig={true}
        />
        : <img src={image} style={styles.Image} alt={label} />}
    </Paper >
  )
}


const HomeCatalogo = () => {
  const randomQueryString = Math.random().toString(36).substring(7);
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const CategoriesSitesImages = {
    BoxImageStart: [

      {
        label: "Escritura",
        image: `${process.env.PUBLIC_URL}/assets/Banners/escritura.jpg`, //?${randomQueryString}
      },
      {
        label: "Escolar",
        image: `${process.env.PUBLIC_URL}/assets/Banners/escolar.jpg`,
      },
    ],
    BoxImageCenter: [
      {
        label: "Lanzamientos",
        image: `${process.env.PUBLIC_URL}/assets/Banners/lanzamientos.jpg`,
      },
      {
        label: "Papeles",
        image: `${process.env.PUBLIC_URL}/assets/Banners/papeles.jpg`,
      },
    ],
    BoxImageEnd: [
      {
        label: "Dibujo técnico",
        image: `${process.env.PUBLIC_URL}/assets/Banners/dibujo-tecnico.jpg`,
      },
      {
        label: "Oficina",
        image: `${process.env.PUBLIC_URL}/assets/Banners/oficina.jpg`,
      },
    ]
  };

  return (
    <>
      <Grid container sx={isMobile ? { display: "flex", flexDirection: "column", gap: "10px" } : { height: "70vh", marginTop: "10px", marginBottom: "10px", padding: "10px" }}>
        {!isMobile ? <Grid item sm={12} sx={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "35%", gap: "20px" }}>
            {CategoriesSitesImages.BoxImageStart.map((section, index) => (
              <BoxImageContainer key={index} {...section} index={index} flex={0.5} />
            ))}
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", width: "35%", gap: "20px" }}>
            {CategoriesSitesImages.BoxImageCenter.map((section, index) => (
              <BoxImageContainer key={index} {...section} index={index} flex={0.5} isImage={index === 0} />
            ))}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", width: "35%", gap: "20px" }}>
            {CategoriesSitesImages.BoxImageEnd.map((section, index) => {
              return <BoxImageContainer key={index} {...section} index={index} flex={0.5} />
            })}
          </Box>
        </Grid> :
          <>
            {CategoriesSitesImages.BoxImageStart.map((section, index) => (
              <Mobile key={index} {...section} index={index} />
            ))}
            {CategoriesSitesImages.BoxImageCenter.map((section, index) => (
              <Mobile key={index} {...section} index={index} />
            ))}
            {CategoriesSitesImages.BoxImageEnd.map((section, index) => {
              return <Mobile key={index} {...section} index={index} />
            })}
          </>
        }
      </Grid >
      <Box sx={{ height: "55px", textAlign: "center", marginBottom: "15px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography sx={{ textTransform: "uppercase", fontSize: "25px" }}>Productos destacados</Typography>
        <Divider sx={{ width: "95%" }} />
      </Box>
      <Catalogo inicio={true} />
    </>
  );
};

export default HomeCatalogo;
